import React, { useState, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { IComment } from './AllForCommentList';
import './NewUserTransition.scss';
import { ThemeContext } from '../../store/ThemeProvider';
import intl from 'react-intl-universal';
import { alpha, getPendantColor } from '../../utils/color';
import { style } from '../../utils/image';

let userList = [] as any[];

const NewUserTransition = () => {
  const { mainColor, h1Color, componentColor } = useContext(ThemeContext);
  const [bgColor, foreColor] = getPendantColor(mainColor, true);

  const [list, setList] = useState([] as any[]);

  useEffect(() => {
    const clearLast = () => {
      userList.shift();
      setList([...userList]);
    };

    let timer = 0;
    const onUserMessage = (e: Event) => {
      let { data } = e;
      if (data) {
        userList = userList.concat(data.list);
        let newList = [...userList];
        setList(newList);
        timer = window.setTimeout(clearLast, 3000);
      }
    };

    window.addEventListener('custom-comment-newuser-transition', onUserMessage);

    return () => {
      window.removeEventListener(
        'custom-comment-newuser-transition',
        onUserMessage
      );

      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="newuser-transition">
      <div className="wrapper">
        {(list || [])
          .map((it: any, index) => {
            if (index > 2) {
              return null;
            }

            const { nick_name } = it;

            return (
              <div className="animate" key={nick_name + ' ' + index}>
                <div className="content">
                  {nick_name}
                  {intl.get('ChatRoomJoin')}
                </div>
              </div>
            );
          })
          .filter(Boolean)}
      </div>
    </div>
  );
};

export default NewUserTransition;
